import GetAppIcon from "@mui/icons-material/GetApp";
import {
  Alert,
  AlertTitle,
  Box,
  Card,
  CardContent,
  IconButton,
  List,
  ListItem,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import type React from "react";
import { Link } from "react-router";

// Extension URL from the main configuration file
const EXTENSION_URL =
  "https://chromewebstore.google.com/detail/desplegaai/aepkdgbeeieghfmolahpnlechohcinlg";

interface ExtensionTabProps {
  apiDisabled: boolean;
}

export const ExtensionTab: React.FC<ExtensionTabProps> = ({ apiDisabled }) => {
  return (
    <Card>
      <CardContent>
        <Stack direction="column" spacing={2} alignItems="stretch" justifyContent="stretch">
          <Box>
            <Typography variant="h5" component="div">
              Browser Extension
            </Typography>
            <Typography variant="body2" mt={1} color="text.secondary">
              Install and configure the desplega.ai browser extension
            </Typography>
          </Box>
          <Alert
            variant="standard"
            severity="warning"
            icon={false}
            action={
              <Tooltip title="Download Extension">
                <IconButton
                  size="small"
                  component={Link}
                  to={EXTENSION_URL}
                  target="_blank"
                  disabled={apiDisabled}
                  color="inherit"
                  aria-label="Download Extension"
                >
                  <GetAppIcon />
                </IconButton>
              </Tooltip>
            }
          >
            <AlertTitle>Extension required</AlertTitle>
            <Typography variant="body2" color="text.secondary">
              To record and run tests, you need to install our browser extension.
            </Typography>
          </Alert>
          <Box>
            <Typography variant="subtitle1" component="div">
              Install instructions
            </Typography>
            <List>
              <ListItem>
                <Typography variant="body2" color="text.secondary">
                  1. Download the extension via the{" "}
                  <Link to={EXTENSION_URL} target="_blank">
                    official Chrome Web Store
                  </Link>
                </Typography>
              </ListItem>
              <ListItem>
                <Typography variant="body2" color="text.secondary">
                  2. Setup your API key in the extension
                </Typography>
              </ListItem>
              <ListItem>
                <Typography variant="body2" color="text.secondary">
                  3. Go to the page you want to record and click on the extension icon to start
                  recording
                </Typography>
              </ListItem>
              <ListItem>
                <Typography variant="body2" color="text.secondary">
                  4. Once the recording is finished, go back to the dashboard to see the results!
                </Typography>
              </ListItem>
            </List>
          </Box>
        </Stack>
      </CardContent>
    </Card>
  );
};
